<template>
  <GridContainer
    v-if="seoContent"
    padding
    class="shop-list-seo"
  >
    <div v-if="seoContent.faqs">
      <Heading
        tag="h2"
        size="md"
        align="center"
        spaces-top
        spaces-bottom
      >
        Häufig gestellte Fragen für
        <template v-if="pageHeadline">{{ pageHeadline }}</template>
      </Heading>

      <template
        v-for="(entry, key) in seoContent.faqs"
        :key="key"
      >
        <AccordionItem>
          <template #title>
            <h3 v-html="entry.question" />
          </template>
          <template #content>
            <div
              class="unstyled-html"
              v-html="entry.answer"
            />
          </template>
        </AccordionItem>
      </template>
    </div>
    <template v-if="seoContent.description">
      <Heading
        tag="h2"
        size="md"
        align="center"
        spaces-top
        spaces-bottom
      >
        Entdecken Sie die Auswahl für
        <template v-if="pageHeadline">{{ pageHeadline }}</template>
      </Heading>
      <div
        class="shop-list__seo unstyled-html"
        v-html="seoContent.description"
      />
    </template>
  </GridContainer>
</template>

<script setup lang="ts">
import { seoContentEntries } from '~/lib/seo/seo-texts';
import { AccordionItem, GridContainer, Heading } from '@i22team/td-longtail-vue-components';
import { useHead } from '#imports';

const props = defineProps({
  routeSlug: {
    type: String,
    default: null,
  },
  pageHeadline: {
    type: String,
    default: null,
  },
});

const seoContent = computed(() => seoContentEntries[props.routeSlug?.replace(/^\//, '')]);

const faqJson = computed(() => {
  if (!seoContent.value?.faqs) return undefined;
  return {
    '@context': 'https://schema.org/',
    '@type': 'FAQPage',
    mainEntity: seoContent.value.faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
});

useHead(() => {
  if (!faqJson.value) return {};
  return {
    script: {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(faqJson.value, null, ''),
    },
  };
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
.shop-list-seo {
  margin-bottom: $grid-base * 3;
}
</style>
